import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hideBalance'
})
export class HideBalancePipe implements PipeTransform
{
    transform(value: string, ...args: unknown[]): unknown
    {
        if (value)
        {
            return value.split('').map(val => !val.match(/[0-9]/g) ? val : '*').join('');
        }
        return value;
    }
}
